var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3333 13C10.7627 13.5741 11.3106 14.0491 11.9398 14.3929C12.569 14.7367 13.2648 14.9411 13.9799 14.9923C14.695 15.0435 15.4128 14.9403 16.0846 14.6897C16.7564 14.4392 17.3664 14.047 17.8733 13.54L20.8733 10.54C21.784 9.59695 22.288 8.33394 22.2766 7.02296C22.2652 5.71198 21.7394 4.45791 20.8123 3.53087C19.8853 2.60383 18.6312 2.07799 17.3203 2.0666C16.0093 2.0552 14.7463 2.55918 13.8033 3.46997L12.0833 5.17997",
    stroke: "#115099",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3332 11C13.9038 10.4259 13.3558 9.9508 12.7267 9.60704C12.0975 9.26328 11.4017 9.05886 10.6866 9.00765C9.97141 8.95643 9.25362 9.05961 8.58186 9.3102C7.9101 9.56079 7.30009 9.95291 6.79321 10.46L3.79321 13.46C2.88242 14.403 2.37845 15.666 2.38984 16.977C2.40123 18.288 2.92707 19.542 3.85411 20.4691C4.78116 21.3961 6.03522 21.922 7.3462 21.9334C8.65719 21.9447 9.9202 21.4408 10.8632 20.53L12.5732 18.82",
    stroke: "#115099",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.86ccc45f.svg";
export { ForwardRef as ReactComponent };